import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 9l3 5.063","key":"svg-0"}],["path",{"d":"M4 9l6 6","key":"svg-1"}],["path",{"d":"M4 15l6 -6","key":"svg-2"}],["path",{"d":"M20 9l-4.8 9","key":"svg-3"}]]

const IconMathXy = createReactComponent('outline', 'math-xy', 'MathXy', __iconNode);

export default IconMathXy;